import { Component, Inject, OnInit } from '@angular/core';
import { PaymentService, PersonalData } from '../../services/payment.service';
import { LiabilityDataModel } from '../../models/liability-data.model';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { TransferMethodForm } from '../../forms/transfer-method.form';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaymentMethod } from '../../models/payment-method.model';
import { PaymentTypeEnum } from '../../models/payment-type.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PaymentApiService } from '../../services/payment-api.service';
import { ImojeActiveBankModel } from '../../models/imoje-active-bank.model';
import { BANK_IMAGES } from '../../utils/bank-images';
import { CURRENT_THEME_HOLDER } from '../../../themes';
import { Router } from '@angular/router';

@Component({
  selector: 'app-transfer-payment-dialog',
  templateUrl: './transfer-payment-dialog.component.html',
  styleUrls: ['./transfer-payment-dialog.component.scss']
})
export class TransferPaymentDialogComponent implements OnInit {
  CURRENT_THEME_HOLDER = CURRENT_THEME_HOLDER;
  payment: LiabilityDataModel;
  activeBanks$: Observable<ImojeActiveBankModel[]>;
  retry$ = new BehaviorSubject(undefined);
  error = false;
  skeletonTiles = new Array(25);
  images = BANK_IMAGES;
  form = new TransferMethodForm();
  submitted = false;

  constructor(
    private paymentService: PaymentService,
    private paymentApiService: PaymentApiService,
    private matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) private data: TransferPaymentDialogData,
    private dialogRef: MatDialogRef<TransferPaymentDialogComponent>,
    private router: Router
  ) {
    this.activeBanks$ = this.retry$.pipe(
      switchMap(() => this.loadTiles()),
      catchError(err => {
        this.error = true;
        return throwError(err);
      })
    );
  }

  ngOnInit(): void {
    this.payment = this.paymentService.payment;
  }

  retry() {
    this.error = false;
    this.retry$.next(undefined);
  }

  submit() {
    if (!!this.form.methodCode.value) {
      this.submitted = true;
      this.paymentService
        .createImojeTransaction(
          PaymentMethod.TRANSFER,
          this.data.personalData.name,
          this.data.personalData.surname,
          this.data.personalData.email,
          this.data.paymentType,
          this.form.methodCode.value
        )
        .subscribe({
          error: () => {
            this.dialogRef.close();
            this.router.navigate(['/error']);
          }
        });
    } else {
      this.matSnackBar.open('Aby kontynuować, wybierz metodę płatności', null, {
        verticalPosition: 'top',
        horizontalPosition: 'center',
        duration: 5000,
        panelClass: 'snackbar-warning'
      });
    }
  }

  select(tile: ImojeActiveBankModel) {
    if (tile.isOnline) {
      this.form.methodCode.setValue(tile.code);
    }
  }

  private loadTiles(): Observable<ImojeActiveBankModel[]> {
    return this.paymentApiService.getActiveBanks(
      this.paymentService.token,
      this.data.paymentType === PaymentTypeEnum.BALANCE
    );
  }
}

interface TransferPaymentDialogData {
  personalData: PersonalData;
  paymentType: PaymentTypeEnum;
}
